import styled, { css } from 'styled-components';

export default styled.div`
  ${({ px, height }) => css`
    padding: 15px;
    height: ${height ?? ''};
    @media only screen and (min-width: 768px) {
      padding: 20px ${px ?? '65px'};
    }
  `}
`;